export default __webpack_public_path__ + "img/cZIaYJtS.21abfe1a.svg";